import { Head } from '@unhead/react';

import AppSettings from '../constants';

export const GoogleAnalyticsScript = () => {
    const googleAnalyticsId = AppSettings.googleAnalyticsId;

    if (!googleAnalyticsId) {
        return null;
    }

    return (
        <Head>
            <script async src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`} />
            <script>
                {`
                    window.dataLayer = window.dataLayer || [];
                    function gtag() {
                        dataLayer.push(arguments);
                    }
                    gtag('js', new Date());

                    gtag('config', '${googleAnalyticsId}');

                    window.addEventListener('pushstate', () => {
                        gtag('event', 'page_view', {
                            page_location: window.location.href,
                        });
                    });
                `}
            </script>
        </Head>
    );
};
